import request from '@/utils/sap-request'

// 销售计划单查询&修改
export const getSaleList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/plaorderserch',
    method: 'POST',
    data
  })
}

// 销售计划单查询&修改（审核通过）
export const apiSaleResolve = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/plaorderserch01',
    method: 'POST',
    data
  })
}

// 销售计划单查询&修改（审核拒绝）
export const apiSaleReject = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/plaorderserch02',
    method: 'POST',
    data
  })
}

// 销售计划单创建
export const apiSalePlanCreate = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/salesplanadd',
    method: 'POST',
    data
  })
}

// 销售计划变更单创建
export const apiSalePlanChangeCreate = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/salplnchge_save',
    method: 'POST',
    data
  })
}

// 销售计划单据详情
export const getSalePlanByNumber = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/planserch03',
    method: 'POST',
    data
  })
}

// 销售计划单据（公司/营销单元）详情
export const getSalePlanCompnayByNumber = (data) => {
  return request({
    url: '/sap/bc/ztpm/to_new_crm/transdata/planserch04',
    method: 'POST',
    data
  })
}

// 销售计划单据（公司/营销单元）创建
export const getSalePlanCompnayCreate = (data) => {
  return request({
    url: '/sap/bc/ztpm/to_new_crm/transdata/planorder01',
    method: 'POST',
    data
  })
}

// 销售计划变更单据（公司/营销单元）创建
export const getSalePlanCompnayChangeCreate = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/planorderchange',
    method: 'POST',
    data
  })
}

// 销售计划查询
export const getSalePlanList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/planserch',
    method: 'POST',
    data
  })
}

// 根据销售计划编号查询详情
export const getSalePlanNum = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/planserch001',
    method: 'POST',
    data
  })
}

// 销售计划单查询(公司/营销单元)
export const getSaleCompnayList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/planserch01',
    method: 'POST',
    data
  })
}

// 根据销售计划(公司/营销单元)计划编号查询详情
export const getSaleCompnayPlanNum = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/planserch002',
    method: 'POST',
    data
  })
}

// 销售计划查询(公司/营销单元)
export const getSalePlanCompnayList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/planserch02',
    method: 'POST',
    data
  })
}

// 销售计划转移单
export const getTranstionList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/plantransserch',
    method: 'POST',
    data
  })
}

// 销售计划转移单创建
export const getTranstionCreate = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/planordertrans',
    method: 'POST',
    data
  })
}

// 销售计划批导查询
export const apiSaleImportList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/planbatchguide',
    method: 'POST',
    data
  })
}

// 销售计划批导模版下载
export const apiSaleDownTemlate = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/down_template',
    method: 'POST',
    data
  })
}

// 销售计划批导查询批次号
export const apiSaleImportBatchNumDetail = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/plnbatchguide04',
    method: 'POST',
    data
  })
}

// 销售计划批导(数据检查)
export const apiSaleImportBatchCheck = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/plnbatchguide02',
    method: 'POST',
    data
  })
}

// 销售计划(公司/营销单元)批导(数据检查)
export const apiSaleComImportBatchCheck = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/plnbatchguide05',
    method: 'POST',
    data
  })
}

// 销售计划（公司/营销单元）批导导入
export const apiSaleComImportBatchConfirm = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/plnbatchguide06',
    method: 'POST',
    data
  })
}

// 销售计划批导导入
export const apiSaleImportBatchConfirm = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/plnbatchguide01',
    method: 'POST',
    data
  })
}

// 销售计划批导取消
export const apiSaleImportBatchCancel = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/plnbatchguide03',
    method: 'POST',
    data
  })
}

// 销售计划汇总报表查询
export const apiSalePlansumserch = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/plansumserch',
    method: 'POST',
    data
  })
}

// 销售计划汇总报表查询（新版）
export const apiSalePlansumserch02 = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/plansumserch02',
    method: 'POST',
    data
  })
}

// 销售计划转移单详情查询
export const apiSalePlanTransformDetail = (data) => {
  return request({
    url: '/sap/bc/ztpm/to_new_crm/transdata/PLANSERCH003',
    method: 'POST',
    data
  })
}

// 销售计划变更单创建(营销战区)
export const apiSalePlanChangeCreateTheater = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/planorderregion',
    method: 'POST',
    data
  })
}

// 销售计划战区变更控制表
export const apiSalePlanChangeTheater = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_sp_tccs',
    method: 'POST',
    data
  })
}

// 销售计划战区变更控制表操作
export const apiSalePlanChangeTheaterFunc = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/sp_tccs_func',
    method: 'POST',
    data
  })
}

// 销售计划汇总显示详情
export const apiSalePlanCountDetail = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_plan_hzmx',
    method: 'POST',
    data
  })
}

// 销售计划冻结/解冻
export const apiSalesplanBlock = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/salesplan_block',
    method: 'POST',
    data
  })
}

// 销售计划批导中导出
export const apiSalesplanBatchExport = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/plnbatchguide07',
    method: 'POST',
    data
  })
}

// 销售计划批导中打印
export const apiSalesplanBatchPrint = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/plnbatchguide07',
    method: 'POST',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/sap/sale-plan.js